import type { VariantProps } from 'class-variance-authority';
import type { RouteLocationRaw } from 'vue-router';

import { cva } from 'class-variance-authority';

export { default as NavigationSection } from './Navigation.vue';

export interface NavigationSectionLink {
	label: string;
	route?: string | RouteLocationRaw;
	action?: Function;
	openInNewTab?: boolean;
}

export interface NavigationSectionItem {
	title: string;
	links: NavigationSectionLink[];
	legend?: string;
}

export const titleVariants = cva(
	'font-matter-sq text-2xl font-normal leading-[150%] tracking-tighter',
	{
		variants: {
			color: {
				white: 'text-white',
				primary: 'text-primary'
			}
		},
		defaultVariants: {
			color: 'white'
		}
	}
);

export type TitleVariants = VariantProps<typeof titleVariants>;

export const labelVariants = cva(
	'cursor-pointer text-start text-base font-normal leading-[150%] underline underline-offset-8 transition ease-in-out',
	{
		variants: {
			color: {
				white: 'text-white decoration-primary-light-1',
				primary: 'text-primary decoration-primary/20 hover:decoration-primary'
			}
		},
		defaultVariants: {
			color: 'white'
		}
	}
);

export const linksContainerVariants = cva('flex flex-col items-start ', {
	variants: {
		variant: {
			default: 'gap-y-3',
			seo: 'gap-y-4'
		}
	},
	defaultVariants: {
		variant: 'default'
	}
});

export const linksContainerWrapperVariants = cva('flex', {
	variants: {
		variant: {
			default: 'w-full flex-col gap-8 lg:flex-row lg:justify-between',
			column: 'flex-col gap-y-8'
		}
	},
	defaultVariants: {
		variant: 'default'
	}
});

export type LinksContainerVariants = VariantProps<
	typeof linksContainerVariants
>;

export type LinksContainerWrapperVariants = VariantProps<
	typeof linksContainerWrapperVariants
>;
